module.exports = __webpack_public_path__ + "static/media/DSC04282-3.79cdc7b9.jpg";